import { Flex, Typography } from "antd";
import { SummaryTitle } from "components/StartContent/styled";
import { TRACKING } from "config/consts";
import { useApp } from "contexts/AppProvider";
import dayjs from "dayjs";
import { useEffect } from "react";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";

export const ThankYou = () => {
  const { formatMessage, locale } = useIntl();
  const navigate = useNavigate();
  const { setActiveStep, reservationPayload, activeTimeslot, getBranchById, settings, confirmationData, price } = useApp();
  const branch = activeTimeslot ? getBranchById(activeTimeslot.branchId) : null;
  const visitPrice = confirmationData?.price ?? price;

  useEffect(() => {
    if (activeTimeslot) {
      setActiveStep(TRACKING.FINALIZED);
    }
  }, [activeTimeslot]);

  if (!activeTimeslot) {
    navigate(`/${location.search}`);
    return null;
  }

  return (
    <div style={{ textAlign: "center" }}>
      <SummaryTitle>{formatMessage({ defaultMessage: "Wizyta została umówiona!", id: "nN960/" })}</SummaryTitle>
      <Flex vertical>
        <div style={{ marginBottom: 15 }}>
          <Typography.Text>
            {formatMessage({ defaultMessage: "Dziękujemy za skorzystanie z naszych usług.", id: "cktxp1" })}
          </Typography.Text>
        </div>
        <div style={{ marginBottom: 15 }}>
          <div>
            <Typography.Text>
              {formatMessage({ defaultMessage: "Wizyta została umówiona na", id: "ZSKDV1" })}{" "}
              <strong>{dayjs(activeTimeslot.date).format("DD MMMM YYYY")}</strong>{" "}
              {formatMessage({ defaultMessage: "na godzinę", id: "DY4EoQ" })}{" "}
              <strong>{activeTimeslot.startTime}</strong>
            </Typography.Text>
          </div>
          <div>
            <Typography.Text style={{ marginRight: 10, display: "inline-block", minWidth: 110 }}>
              {formatMessage({ defaultMessage: "Adres gabinetu", id: "IvLSQl" })}
              {": "}
              <strong>
                {reservationPayload.isOnline ||activeTimeslot.isOnline
                  ? formatMessage({ defaultMessage: "Wizyta online", id: "iysARY" })
                  : branch
                    ? `${branch.street}, ${branch.city}`
                    : ""}
              </strong>
            </Typography.Text>
          </div>

          <div>
            <Typography.Text>
              {formatMessage({ defaultMessage: "Wizyta u", id: "oz42dx" })}{" "}
              <strong>
                {activeTimeslot.therapist.user.firstName} {activeTimeslot.therapist.user.lastName}
              </strong>
            </Typography.Text>
          </div>
        </div>
        <div>
          <Typography.Text>
            {formatMessage({
              defaultMessage: "Na podanego maila otrzymasz potwierdzenie wizyty wraz ze szczegółami.",
              id: "BquiSi",
            })}
          </Typography.Text>
        </div>
        <div style={{ marginBottom: 15 }}>
          <Typography.Text>
            {formatMessage({
              defaultMessage: "W przypadku nieotrzymania wiadomości prosimy o szybki kontakt telefoniczny.",
              id: "aJ8bpE",
            })}
          </Typography.Text>
        </div>
        {Number(visitPrice) > 0 && settings?.preferences?.maxBankTransferHours && (
          <div>
            {locale === "pl" ? (
              <Typography.Text>
                <strong>Uwaga</strong>: Jeśli to Twoja pierwsza wizyta w {settings.customer.name}, prosimy o dokonanie
                płatności przelewem w ciągu{" "}
                <strong>{settings.preferences.maxBankTransferHours} godzin OD UMÓWIENIA WIZYTY. </strong>
                Brak wpłaty spowoduje anulowanie wizyty. Szczegóły dotyczące płatności znajdziesz w mailu
                potwierdzającym wizytę.
              </Typography.Text>
            ) : (
              <Typography.Text>
                <strong>Note:</strong> If this is your first visit to the {settings.customer.name}, please make the
                payment via bank transfer within <strong>{settings.preferences.maxBankTransferHours} hours.</strong>{" "}
                Failure to make the payment will result in the cancellation of your appointment. You will find payment
                details in the confirmation email for your appointment.
              </Typography.Text>
            )}
          </div>
        )}

        {/* <Typography.Text>{formatMessage({ defaultMessage: "Cena:", id: "CKHD7g" })}:</Typography.Text> */}
      </Flex>

      {/* <Button type="primary" style={{ marginTop: 20 }}>
        Wróć na stronę główną
      </Button> */}
    </div>
  );
};
